import Swal from 'sweetalert2';
import { api } from '../../../api/api';
import { createActions, handleActions } from 'redux-actions'
import { goBack } from 'react-router-redux'
import { initialize as initializeForm } from 'redux-form'
import { push } from 'react-router-redux';
const url = 'cuenta_area';

const LOADER_CA = 'LOADER_CA';
const SET_DATA_CA = 'SET_DATA_CA';
const SET_PAGE_CA = 'SET_PAGE_CA';
const SET_UPDATE_DATA_CA ='SET_UPDATE_DATA_CA';
const SET_BUSCADOR_CA = 'SET_BUSCADOR_CA';
const SET_FILTRO_CA = 'SET_FILTRO_CA';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_CA, cargando: true});
    const store = getStore();
    const search = store.cuenta_area.buscador;
    const filtro = store.cuenta_area.filtro_ca;
    let params = {page, search};

    if(filtro){
        params[''] = filtro
    }
    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_CA, cargando: false});
        Swal(
            'Error',
            (error && error.detail) ? error.detail : 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_CA, data});
            dispatch({type: SET_PAGE_CA, page});
        }
        dispatch({type: LOADER_CA, cargando: false});
    })
};
const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_CA, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_CA, cargando: false});
        if(error.statusCode  === 404){
            dispatch(push('/admin_cuenta_areas'))
        }
    }).then((data) => {
        dispatch({type: LOADER_CA, cargando: false});
        if(data){
            dispatch({type: SET_UPDATE_DATA_CA, updateData: data});
            dispatch(initializeForm('cuentaarea', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.cuentaarea.values;
    dispatch({type: LOADER_CA, cargando: true})
    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_CA, cargando: false})
        Swal('Éxito', 'Se ha creado la cuenta.', 'success')
        .then(() => {
            dispatch(push('/admin_cuenta_areas'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_CA, cargando: false})
        Swal(
            'Error',
             (error && error.detail) ? error.detail : 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_CA, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.cuentaarea.values);
    dispatch({type: LOADER_CA, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_CA, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/admin_cuenta_areas'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_CA, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/admin_cuenta_areas'));
        }
    })
}
const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_CA, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_CA, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
        })
    }).then((data) => {
        dispatch({type: LOADER_CA, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch, getStore) => {
    dispatch({type: SET_BUSCADOR_CA, buscador: search});
    dispatch(listar(1));
};
const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_CA, filtro_ca: filtro});
    dispatch(listar(1));
};
export const actions = {
    listar,
    detail,
    create,
    update,
    destroy,
    search,
    filtro
};
export const reducer = {
    [LOADER_CA]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_CA]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_CA]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_CA]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_CA]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_CA]: (state, { filtro_ca }) => {
        return {...state, filtro_ca }
    },
}
export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_ca: null,
    updateData: {},
};
export default handleActions(reducer, initialState)
